module.exports = __webpack_public_path__ + "static/media/nexmarketDisabled.9ecc0a26.svg";